var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "imageWrapper", staticClass: "images-wrapper" }, [
    _c("img", {
      staticClass: "before-image",
      style: { width: _vm.width ? `${_vm.width}px` : null },
      attrs: { src: _vm.beforeImage, alt: "Before image" },
      on: { load: _vm.captureWidth },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "compare-overlay",
        style: { width: `${_vm.compareWidth}%` },
      },
      [
        _c("img", {
          staticClass: "after-image",
          style: { width: _vm.width ? `${_vm.width}px` : null },
          attrs: { src: _vm.afterImage, alt: "After image" },
          on: { load: _vm.captureWidth },
        }),
      ]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.compareWidth,
          expression: "compareWidth",
        },
      ],
      staticClass: "compare__range",
      attrs: {
        type: "range",
        min: "0",
        max: "100",
        step: _vm.step,
        tabindex: "-1",
      },
      domProps: { value: _vm.compareWidth },
      on: {
        __r: function ($event) {
          _vm.compareWidth = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "handle-wrap", style: { left: `${_vm.compareWidth}%` } },
      [_vm._m(0), _vm._v(" "), _c("span", { staticClass: "handle-line" })]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "handle" }, [
      _c("i", { staticClass: "fas fa-chevron-left" }),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-chevron-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }